<template>
  <el-dialog
  :visible.sync="dialogVisible"
  width="800px"
  class="feedback-dialog"
  >
  <div style="width: 100%; padding-bottom: 40px;">
    <el-table
      :data="tableData"
      style="width: 100%"
      height="400"
      header-row-class-name="feedback-dialog-table__header"
      >
      <el-table-column
        prop="nickname"
        label="STUDENT"
        align="center"
        width="130">
      </el-table-column>
      <el-table-column
        prop="rating"
        label="RATING"
        align="center"
        width="250">
        <template slot-scope="scope">
          <el-rate
            v-model="scope.row.rating"
            disabled
            text-color="#ff9900">
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        align="center"
        label="FEEDBACK">
      </el-table-column>
    </el-table>
  </div>
</el-dialog>

</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    lessonSn: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getData () {
      // getTeacherComment?lesson_sn=7560f1e1f25e48abac224bc042ad1032
      this.$http.get('/tutor/api/getTeacherComment?lesson_sn=' + this.lessonSn).then(({data: {data}}) => {
        console.log(data, 'res')
        this.tableData = (data || []).map(item => ({...item, rating: item.rating || 0}))
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        console.log(this.lessonSn, 'lessonSn')
        this.getData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.feedback-dialog {
  /deep/ .el-dialog {
    background-color: #FFFAE5;

     .el-dialog__body {
      padding: 24px !important;
      .feedback-dialog-table__header{
        .el-table__cell {
          background: rgba(247, 249, 252, 0.8);
          backdrop-filter: blur(4px);
        }
      }
       .el-table--enable-row-transition{
         background-color: #FFFAE5;
       }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FeedbackTable.vue